import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  pendingRequests = [];
  noLoaderRequests = ['mute', 'red', 'search', 'send_payment_slip'];

  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.noLoaderRequests.some((element: string) => req.url.includes(element) && !req.url.includes('batch'))) {
      return next.handle(req);
    }

    this.pendingRequests.push(req.url);
    this.loaderService.display(true);

    return next.handle(req).pipe(
      finalize(() => {
        this.pendingRequests.splice(
          this.pendingRequests.findIndex((element: string) => element === req.url),
          1
        );
        if (!this.pendingRequests.length) {
          this.loaderService.display(false);
        }
      })
    );
  }
}
